const path = window.require("path");
const { app } = window.require("@electron/remote");
const protobuf = window.require("protobufjs");

function getRoot() {
  if (path && app && protobuf) {
    const communicationPath = path.join(
      app.getAppPath(),
      "modules/babyCustomization-protobuf/babyCustomization.proto"
    );
    const protoRoot = protobuf.loadSync(communicationPath);

    return protoRoot;
  }

  return new Proxy(
    {},
    {
      get(obj, prop) {
        if (window.babyCustomizationRoot) {
          return window.babyCustomizationRoot[prop];
        }

        if (prop === "lookupType") return () => undefined;
        if (prop === "lookupEnum") return () => undefined;
        return undefined;
      }
    }
  );
}

const protoRoot = getRoot();

export default protoRoot;

const Type = {
  get AvatarCustomization() {
    return protoRoot.lookupType("babyCustomization.AvatarCustomization");
  }
};
export { Type };
